import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import App from './App';
import 'tailwindcss/tailwind.css';

createRoot(document.getElementById('root')).render(
	<BrowserRouter>
		<div className='min-h-screen bg-[#ffffff]'>
			<App className='m-0 p-0' />
		</div>
	</BrowserRouter>
);

reportWebVitals();
